/**
 * @file: meKit.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * Shared palette for the Me home screen, so its cards stay visually
 * consistent rather than each inventing its own greys.
 */

import { StatusColors } from '@euler/components/Colors';
import { ViewStyle } from 'react-native';

export const MK = {
  canvas: '#f7f7f7',
  ink: '#0f172a',
  // The bottom stop of `NavHeaderBg`, so the hero continues the nav header
  // without a seam.
  brand: StatusColors.Info,
  onBrand: '#ffffff',
  onBrandDim: 'rgba(255, 255, 255, 0.8)',
  onBrandFill: 'rgba(255, 255, 255, 0.2)',
  brandSoft: '#eaf1fc',
  muted: '#f1f5f9',
  mutedInk: '#64748b',
  successSoft: '#e6f6ee',
  success: StatusColors.Success,
  surface: '#ffffff',
  hairline: '#e5e7eb',
  chartOpened: StatusColors.Info,
  chartFinished: StatusColors.Success,
  warn: StatusColors.Warn,
  purple: '#8b5cf6',
  danger: StatusColors.Danger,
} as const;

/** Pale washes of the accent colours, for tinted tiles. */
export const MKTint = {
  brand: 'rgba(38, 105, 219, 0.1)',
  success: 'rgba(0, 170, 85, 0.12)',
  warn: 'rgba(255, 138, 0, 0.14)',
  purple: 'rgba(139, 92, 246, 0.14)',
  danger: 'rgba(224, 70, 61, 0.12)',
} as const;

/** How far the first card rides up over the brand-coloured hero. */
export const kHeroOverlap = 44;

export const cardShadowStyle = (rpx: (n: number) => number): ViewStyle => ({
  shadowColor: '#0f172a',
  shadowOffset: { width: 0, height: rpx(2) },
  shadowOpacity: 0.06,
  shadowRadius: rpx(10),
  elevation: 2,
});
